import React, { useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import api from "../api/index";
import { useAlert } from "react-alert";
import OtpInput from "react-otp-input";
import Modal from "react-bootstrap/Modal";
import { OtpModal } from "./otpModal";
import CountrySelect from "./countrySelect";
import { SliderThumb, TextField } from "@mui/material";
import axios from "axios";
import showPassImg from "../images/showPass.svg";
import hidePass from "../images/hidePass.svg";
import "./auth.css";
import "react-phone-number-input/style.css";
import PhoneInput, {
  formatPhoneNumber,
  formatPhoneNumberIntl,
  isValidPhoneNumber,
} from "react-phone-number-input";
import { useEffect } from "react";
import WAValidator from "multicoin-address-validator";

export const ResetPass = () => {
  const alert = useAlert();
  const { id } = useParams();

  const navigate = useNavigate();
  const [showPass, setShowPass] = useState(false);
  const [data, setData] = useState({
    password: "",
    confirmPassword: "",
  });
  const [loader, setLoader] = useState(false);

  const validators = () => {
    if (!data.password) {
      return "Password is required";
    }
    if (data.password && data.password.length < 8) {
      return "Password must be 8 characters long";
    }
    if (data.password && data.password.length > 30) {
      return "Password must be less than 30 characters long";
    }
    if (!data.confirmPassword) {
      return "Confirm password is required";
    }
    if (data.password !== data.confirmPassword) {
      return "Password and Confirm password not matched";
    }
    if (data.password.includes(" ")) {
      return "Spaces are not allowed in password";
    }

    return false;
  };

  const onTextChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const STRENGTH_NAMES = ["", "Weak", "Fair", "Good", "Strong"];
  const passwordScore = (p) => {
    if (!p) return 0;
    let s = 0;
    if (p.length >= 8) s++;
    if (/[A-Z]/.test(p) && /[a-z]/.test(p)) s++;
    if (/[0-9]/.test(p)) s++;
    if (/[^A-Za-z0-9]/.test(p)) s++;
    return s;
  };

  const onSubmit = async (e) => {
    try {
      e.preventDefault();
      const validatorResponse = await validators();

      if (validatorResponse) {
        return alert.show(validatorResponse);
      }

      setLoader(true);
      const payload = {
        ...data,
        token: id,
      };
      const response = await api.resetPass(payload);
      // console.log(response);
      if (response?.error) {
        // console.log(response?.error);
        setLoader(false);
      }
      if (response?.message == "Link expired") {
        setLoader(false);
        navigate("/");
        return alert.show(response?.message);
      }
      if (response?.success) {
        alert.show("Password saved, now you can login.");
        setLoader(true);
        setTimeout(() => {
          setLoader(false);
          navigate("/login");
        }, 3000);
      } else {
        alert.show(response?.message);
        setLoader(false);
      }
    } catch (e) {
      setLoader(false);

      alert.show("Error while Reset Password");
    }
  };

  const pwScore = passwordScore(data.password);
  const pwMismatch =
    !!data.confirmPassword && data.confirmPassword !== data.password;

  return (
    <>
      <div className="wzAuthStage is-signup">
        <div className="wzAuth-orb o1"></div>
        <div className="wzAuth-orb o2"></div>

        <div className="wzAuth-frame">
          <form noValidate id="contactForm" className="wzAuth-card">
            <div className="wzAuth-head">
              <div className="wzAuth-badge">
                <i className="fa-solid fa-lock" />
              </div>
              <h1>Reset Password</h1>
              <p>Choose a new password for your account.</p>
            </div>

            <div className="wzAuth-form">
              <div className="wzAuth-row">
                <div>
                  <label className="wzAuth-label c-pw" htmlFor="password">
                    Password
                  </label>
                  <div className="wzAuth-field pw">
                    <span className="ic">
                      <i className="fa-solid fa-lock" />
                    </span>
                    <input
                      onChange={(e) => onTextChange(e)}
                      type={showPass ? "text" : "password"}
                      name="password"
                      id="password"
                      required
                      placeholder="Password"
                      className="wzAuth-input"
                    />
                    <button
                      type="button"
                      className="wzAuth-eye"
                      aria-label="Toggle password visibility"
                      onClick={() => setShowPass(!showPass)}
                    >
                      {showPass ? (
                        <img src={showPassImg} alt="" />
                      ) : (
                        <img src={hidePass} alt="" />
                      )}
                    </button>
                  </div>
                </div>
                <div>
                  <label
                    className="wzAuth-label c-confirm"
                    htmlFor="confirmPassword"
                  >
                    Confirm
                  </label>
                  <div
                    className={
                      pwMismatch ? "wzAuth-field pw mismatch" : "wzAuth-field pw"
                    }
                  >
                    <span className="ic">
                      <i className="fa-solid fa-shield-halved" />
                    </span>
                    <input
                      onChange={(e) => onTextChange(e)}
                      type={showPass ? "text" : "password"}
                      name="confirmPassword"
                      id="confirmPassword"
                      required
                      placeholder="Confirm password"
                      className="wzAuth-input"
                    />
                    <button
                      type="button"
                      className="wzAuth-eye"
                      aria-label="Toggle confirm password visibility"
                      onClick={() => setShowPass(!showPass)}
                    >
                      {showPass ? (
                        <img src={showPassImg} alt="" />
                      ) : (
                        <img src={hidePass} alt="" />
                      )}
                    </button>
                  </div>
                </div>
              </div>

              <div className="wzAuth-strength">
                <div className="wzAuth-strength-meta">
                  <span className="k">Password strength</span>
                  <span className="v">
                    {pwMismatch
                      ? "Passwords do not match"
                      : STRENGTH_NAMES[pwScore] || "—"}
                  </span>
                </div>
                <div className="wzAuth-bars">
                  {[0, 1, 2, 3].map((i) => (
                    <i
                      key={i}
                      style={{
                        background:
                          i < pwScore
                            ? ["", "#ef4444", "#f59e0b", "#3b82f6", "#10b981"][
                                pwScore
                              ]
                            : undefined,
                      }}
                    />
                  ))}
                </div>
              </div>

              <button
                onClick={onSubmit}
                type="submit"
                className="wzAuth-submit"
                disabled={loader}
              >
                <span className="wzAuth-shine"></span>
                <span className="label">
                  {loader ? (
                    <>
                      <i
                        className="fa fa-spinner fa-pulse me-2"
                        style={{ position: "relative", top: "-0px" }}
                      ></i>
                      Saving...
                    </>
                  ) : (
                    "Save New Password"
                  )}
                </span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};
